import React, { useState, useEffect } from 'react';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import { useParams } from 'react-router-dom';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import Spinner from 'components/ui/Spinner';
import Sidebar from 'components/modules/carrier/AdminSidebar';
import NotificationsManager from 'components/modules/notifications/manage-notifications';
import { useTranslation } from 'react-i18next';

const Loading = function () {
  return (
    <div className="justify-center lg:col-span-1" style={{ top: '50%' }}>
      <div className="align-middle">
        <span className="text-5xl text-green">
          <Spinner showMessage={false} />
        </span>
      </div>
    </div>
  );
};

const NotificationsSettings = () => {
  const { t } = useTranslation();
  const [carrier, setCarrier] = useState(null);
  const params = useParams();
  const carrierId = params.id;
  const renderSidebar = () => (
    <Sidebar userId={carrierId} activePage="notifications" />
  );
  const breadcrumbs = {
    pages: [
      {
        name: carrier?.name || t('CARRIER'),
        href: `/users/${carrierId}`,
        current: false,
      },
      {
        name: 'Notifications',
        href: `/users/${carrierId}/carrier-settings/notifications`,
        current: true,
      },
    ],
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = async () => {
    const user = await getCustomerV2(carrierId);
    setCarrier(user);
  };

  return (
    <LayoutWithSidebar
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      {carrier ? (
        <NotificationsManager userNotificationPreferences={carrier} />
      ) : (
        <Loading />
      )}
    </LayoutWithSidebar>
  );
};

export default NotificationsSettings;
